import React from 'react'

import Header from '../layout/Header'
import Footer from '../layout/Footer'

const LegalPage = ({history}) => (
    <React.Fragment>
        <Header />
        <div className="page">
            <section className="legal">
                <h2>Impressum</h2>

                <h4>Kontaktadresse</h4>

                <p>
                    Miles & More GmbH<br />
                    Postfach 71 08 26<br />
                    60498 Frankfurt<br />
                    Deutschland
                </p>

                <p>
                    E-Mail: Sie erreichen uns per E-Mail über impressum@milesandmore.com<br />
                    Telefon: Ihr lokales <a href="https://www.miles-and-more.com/online/portal/mam/de/help_and_contact/contact_search?l=de&cid=18002&no-mobile-redirect=Y&sourceTaxonomy=General_Information" target="_blank" rel="noopener noreferrer">Miles & More Service Team</a> erreichen Sie über Hilfe & Kontakt.<br />
                    Internet: www.miles-and-more.com
                </p>

                <h4>Geschäftsadresse</h4>

                <p>
                    Miles & More GmbH<br />
                    MAC Main Airport Center, Unterschweinstiege 8<br />
                    60549 Frankfurt/Main
                </p>

                <h4>Sitz der Gesellschaft</h4>

                <p>
                    Frankfurt am Main
                </p>

                <h4>Registereintragung</h4>

                <p>
                    Amstgericht Frankfurt am Main HRB 116409
                </p>

                <h4>Umsatzsteuer-Ident-Nummer</h4>

                <p>
                    DE 220765038
                </p>

                <h4>Geschäftsführung</h4>

                <p>
                    Gerald Schlögl
                </p>

                <h4>Streitschlichtung</h4>

                <p>
                    Hinweis: Die EU-Kommission bietet die Möglichkeit zur Online-Streitbeilegung auf einer von ihr betriebenen Online-Plattform.
                    Diese Plattform ist unter dem Link <a href="http://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">http://ec.europa.eu/consumers/odr</a> zu erreichen.
                    Unsere E-Mailadresse lautet impressum@milesandmore.com.
                    Zu einer Teilnahme an einem Schlichtungsverfahren sind wir nicht verpflichtet
                    und können Ihnen die Teilnahme an einem solchen Verfahren leider auch nicht anbieten.
                </p>

                <h4>Rechtliche Hinweise</h4>

                <p>
                    Miles & More prüft und aktualisiert die Informationen auf seinen Webseiten ständig.
                    Trotz aller Sorgfalt können sich die Daten inzwischen verändert haben.
                    Eine Haftung oder Garantie für die Aktualität, Richtigkeit und Vollständigkeit
                    der zur Verfügung gestellten Informationen kann daher nicht übernommen werden.
                </p>

                <p>
                    Gleiches gilt auch für alle anderen Webseiten, auf die mittels Hyperlink verwiesen wird.
                    Miles & More ist für den Inhalt der Webseiten, die aufgrund einer solchen Verbindung erreicht werden, nicht verantwortlich.
                    Einige der Informationen und Angebote werden von unseren Partnern als selbständige Dienstleistung erbracht.
                    Bitte beachten Sie, dass für diese Services und Angebote die Geschäftsbedingungen unserer Partner gelten
                    und mit der Aufnahme derer Webseiten auf die Webseiten von Miles & More keine Empfehlung oder Garantie verbunden ist.
                    Für diese Inhalte ist Miles & More nicht verantwortlich. Bei diesen Anbietern handelt es sich nicht um Erfüllungsgehilfen von Miles & More.
                </p>

                <p>
                    Im Übrigen finden die <a href="https://www.miles-and-more.com/online/portal/mam/de/program/information?nodeid=2490851&l=de&cid=18002" target="_blank" rel="noopener noreferrer">Miles & More Teilnahmebedingungen</a> Anwendung.
                </p>

                <p>
                    Des Weiteren behält sich Miles & More das Recht vor, Änderungen oder Ergänzungen der bereitgestellten Informationen vorzunehmen.
                </p>

                <p>
                    Inhalt und Struktur der Miles & More Webseiten sind urheberrechtlich geschützt.
                    Die Vervielfältigung von Informationen oder Daten, insbesondere die Verwendung von Texten,
                    Textteilen oder Bildmaterial, bedarf der vorherigen schriftlichen Zustimmung von Miles & More.
                </p>

                <p>
                    <button onClick={history.goBack}>Back</button>
                </p>
            </section>
        </div>
        <Footer />
    </React.Fragment>
)

export default LegalPage



// WEBPACK FOOTER //
// ./src/components/pages/LegalPage.js